import { useState, useEffect, MouseEvent } from 'react';

import SwitchProps from './type';
import { SwitchStyled, SwitchCircleStyled } from './styled';

const Switch = ({ checked, onChange, ...props }: SwitchProps) => {
  const [checkedState, setCheckedState] = useState(checked);
  const { small, disabled } = props;
  const handleChange = (event: MouseEvent<HTMLButtonElement>) => {
    onChange(event);
    setCheckedState(!checkedState);
  };

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  return (
    <SwitchStyled {...props} checked={checkedState} onClick={handleChange}>
      <SwitchCircleStyled disabled={disabled} small={small} checked={checkedState}>
        <span id="drawIcon"></span>
      </SwitchCircleStyled>
    </SwitchStyled>
  );
};

Switch.defaultProps = {
  checked: false,
  onChange: () => {},
};

export default Switch;
